import React from 'react';
import BackGroundLayout from '../../BackGroundLayout/BackGroundLayout';
import styles from './Resume.module.scss';
import { BASIC_CONTENT } from '../../../App.constant';
import InfoCard from '../../InfoCard/InfoCard';
import Progressbar from '../../ProgressBar/Progressbar';

function Resume() {
  return (
    <div id="resume" className={styles.container}>
      <BackGroundLayout backGroundText="Summary" overlapText="Resume" />
      <div className={styles.wrapperContent}>
        <div className={styles.mainContent}>
          <div className={styles.leftPanelContent}>
            <h2 className={styles.header}>My Education</h2>
            {
              BASIC_CONTENT.studies.map((value) => (
                // eslint-disable-next-line react/jsx-key
                <InfoCard value={value} />
              ))
            }
          </div>
          <div className={styles.rightPanelContent}>
            <h2 className={styles.header}>My Experience</h2>
            {
              BASIC_CONTENT.work_experience.map((value) => (
                // eslint-disable-next-line react/jsx-key
                <InfoCard value={value} />
              ))
            }
          </div>
        </div>
        {/* <DownloadBtn /> */}
        <div className={styles.skillsPanel}>
          <h2 className={styles.header}>My Skills</h2>
          <div className={styles.progressBarContainer}>
          {BASIC_CONTENT.skills.map(({ title = '', percentage = ''  }) =>
            // eslint-disable-next-line react/jsx-key
            <Progressbar title={title} percentage={percentage} />
)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Resume